(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-brands"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-section-brands')) {
		class LTASectionBrands extends HTMLElement {
			disconnectedCallback() {
				;(this._timers ?? []).forEach((id) => clearTimeout(id))
				this._timers = []
				this._observer?.disconnect()
				this._observer = null
			}

			connectedCallback() {
				const cards = [...this.querySelectorAll('.l-sBrands__cards .l-sBrands__card')]
				if (!cards.length || this._done || this._observer) return

				const emitDone = () => this.dispatchEvent(new CustomEvent('l:section-brands:revealed', { bubbles: true }))

				const reveal = () => {
					if (this._done) return
					this._done = true
					this._observer?.disconnect()
					this._observer = null

					const instant = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches
					const stagger = instant ? 0 : Math.max(0, Number.parseInt(this.dataset.staggerMs, 10) || 72)

					;(this._timers ?? []).forEach((id) => clearTimeout(id))
					this._timers = []

					if (stagger <= 0) {
						cards.forEach((c) => c.classList.add('is-active'))
						requestAnimationFrame(emitDone)
						return
					}

					cards.forEach((card, i) => {
						this._timers.push(
							setTimeout(() => {
								card.classList.add('is-active')
								if (i === cards.length - 1) requestAnimationFrame(emitDone)
							}, i * stagger)
						)
					})
				}

				if (!('IntersectionObserver' in window)) {
					reveal()
					return
				}

				// Centre band: negative top/bottom margin shrinks IO root to a strip around viewport midline.
				const raw = Number.parseInt(this.dataset.centerInsetPercent, 10)
				const inset = Number.isFinite(raw) ? Math.min(48, Math.max(26, raw)) : 38
				const rootMargin = `-${inset}% 0px -${inset}% 0px`

				this._observer = new IntersectionObserver(
					(entries) => {
						if (!entries.some((e) => e.isIntersecting)) return
						reveal()
					},
					{ root: null, rootMargin, threshold: 0 }
				)

				this._observer.observe(this)
			}
		}

		customElements.define('l-section-brands', LTASectionBrands)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-find-us-in-store"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-find-us-in-store')) {
		class LTAFindUsInStore extends HTMLElement {
			static PARALLAX_RANGE_PX = 300

			connectedCallback() {
				this.background =
					this.closest('.l-sFUIStore')?.querySelector('.l-section-bg') ?? this.querySelector('.l-section-bg')

				if (!this.background) return

				this._onScroll = this._onScroll.bind(this)
				this._observer = new IntersectionObserver(
					([entry]) => {
						if (entry.isIntersecting) {
							window.addEventListener('scroll', this._onScroll, { passive: true })
							this._onScroll()
						} else {
							window.removeEventListener('scroll', this._onScroll)
						}
					},
					{ threshold: 0 }
				)

				this._observer.observe(this)
			}

			disconnectedCallback() {
				this._observer?.disconnect()
				window.removeEventListener('scroll', this._onScroll)

				if (this._frame) cancelAnimationFrame(this._frame)
			}

			_onScroll() {
				if (this._frame) return

				this._frame = requestAnimationFrame(() => {
					this._frame = null

					const rect = this.getBoundingClientRect()
					const viewHeight = window.innerHeight

					if (rect.top > viewHeight || rect.bottom < 0) return

					const scrolledPercentage = (viewHeight - rect.top) / (viewHeight + rect.height)
					const moveAmount = (scrolledPercentage - 0.5) * LTAFindUsInStore.PARALLAX_RANGE_PX

					this.background.style.transform = `translateY(${moveAmount}px)`
				})
			}
		}

		customElements.define('l-find-us-in-store', LTAFindUsInStore)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-media-content-tabs"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-mc-tabs')) {
		class LTASMCTabs extends HTMLElement {
			constructor() {
				super()

				this._onTriggerClick = this._onTriggerClick.bind(this)
				this._onBlockSelect = this._onBlockSelect.bind(this)
			}

			connectedCallback() {
				this.triggerEls = [...this.querySelectorAll('[data-trigger]')]
				this.contentEls = [...this.querySelectorAll('[data-content]')]
				this.swiperCarouselEl = this.querySelector('l-swiper-carousel')

				if (!this.triggerEls.length || !this.contentEls.length) return

				this.triggerEls.forEach((triggerEl) => {
					triggerEl.addEventListener('click', this._onTriggerClick)
				})

				const activeTrigger =
					this.triggerEls.find((triggerEl) => triggerEl.classList.contains('is-active')) || this.triggerEls[0]

				this.activate(activeTrigger.dataset.trigger, { scroll: false })

				if (window.Shopify?.designMode) {
					document.addEventListener('shopify:block:select', this._onBlockSelect)
				}
			}

			disconnectedCallback() {
				this.triggerEls?.forEach((triggerEl) => {
					triggerEl.removeEventListener('click', this._onTriggerClick)
				})

				document.removeEventListener('shopify:block:select', this._onBlockSelect)
			}

			_onTriggerClick(event) {
				this.activate(event.currentTarget.dataset.trigger)
			}

			activate(id, { scroll = true } = {}) {
				if (!id) return

				this.triggerEls.forEach((triggerEl) => {
					const isActive = triggerEl.dataset.trigger === id

					triggerEl.classList.toggle('is-active', isActive)
					triggerEl.setAttribute('aria-selected', isActive ? 'true' : 'false')
				})

				this.contentEls.forEach((contentEl) => {
					contentEl.classList.toggle('l-hidden', contentEl.dataset.content !== id)
				})

				if (scroll && this.swiperCarouselEl?.slideTo) {
					const index = this.triggerEls.findIndex((triggerEl) => triggerEl.dataset.trigger === id)

					if (index >= 0) this.swiperCarouselEl.slideTo(index)
				}
			}

			_onBlockSelect(event) {
				if (!this.contains(event.target)) return

				const triggerEl = event.target.closest('[data-trigger]')
				const contentEl = event.target.closest('[data-content]')

				if (triggerEl) {
					this.activate(triggerEl.dataset.trigger, { scroll: false })
					return
				}

				if (contentEl) {
					this.activate(contentEl.dataset.content, { scroll: false })
				}
			}
		}

		customElements.define('l-mc-tabs', LTASMCTabs)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-product-recommendations"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-product-recommendations')) {
		class LTAProductRecommendations extends HTMLElement {
			constructor() {
				super()

				this._observer = null
			}

			connectedCallback() {
				this._initObserver()
			}

			disconnectedCallback() {
				this._observer?.disconnect()
			}

			_initObserver() {
				this._observer?.disconnect()
				this._observer = new IntersectionObserver(
					(entries, observer) => {
						const entry = entries[0]
						if (!entry.isIntersecting) return
						observer.unobserve(this)
						this._loadRecommendations()
					},
					{ rootMargin: '0px 0px 400px 0px' }
				)
				this._observer.observe(this)
			}

			async _loadRecommendations() {
				try {
					const response = await fetch(this.dataset.url)
					const text = await response.text()

					const html = document.createElement('div')
					html.innerHTML = text

					const recommendations = html.querySelector('l-product-recommendations')
					const hasRecommendations = recommendations && recommendations.innerHTML.trim().length > 0

					if (hasRecommendations) {
						this.innerHTML = recommendations.innerHTML
					} else if (this.parentElement) {
						this.parentElement.classList.add('l-hidden')
					}
				} catch (e) {
					console.error(e)
				} finally {
					okeWidgetApi?.initAllWidgets?.()
				}
			}
		}

		customElements.define('l-product-recommendations', LTAProductRecommendations)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-serama-why-us"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-section-why-us')) {
		class LTASectionWhyUs extends HTMLElement {
			connectedCallback() {
				this.cursor = this.querySelector('[data-cursor]')
				this.cards = [...this.querySelectorAll('.l-sWHUsV2__card[data-card]')]
				this.backgrounds = [...this.querySelectorAll('.l-sWHUsV2__background[data-card]')]

				if (this.cursor) {
					this.cursor.style.opacity = '0'
					this.cursor.style.pointerEvents = 'none'
				}

				this._canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches

				this._handlePointerEnter = this._handlePointerEnter.bind(this)
				this._handlePointerMove = this._handlePointerMove.bind(this)
				this._handlePointerLeave = this._handlePointerLeave.bind(this)
				this._handleCardClick = this._handleCardClick.bind(this)
				this._handleCardPointerEnter = this._handleCardPointerEnter.bind(this)
				this._handleCardPointerLeave = this._handleCardPointerLeave.bind(this)

				this.addEventListener('pointerenter', this._handlePointerEnter)
				this.addEventListener('pointermove', this._handlePointerMove)
				this.addEventListener('pointerleave', this._handlePointerLeave)

				this.cards.forEach((card) => {
					card.addEventListener('click', this._handleCardClick)

					if (this._canHover) {
						card.addEventListener('pointerenter', this._handleCardPointerEnter)
						card.addEventListener('pointerleave', this._handleCardPointerLeave)
					}
				})
			}

			disconnectedCallback() {
				this.removeEventListener('pointerenter', this._handlePointerEnter)
				this.removeEventListener('pointermove', this._handlePointerMove)
				this.removeEventListener('pointerleave', this._handlePointerLeave)
				this.cards?.forEach((card) => {
					card.removeEventListener('click', this._handleCardClick)
					card.removeEventListener('pointerenter', this._handleCardPointerEnter)
					card.removeEventListener('pointerleave', this._handleCardPointerLeave)
				})

				if (this._frame) cancelAnimationFrame(this._frame)
			}

			_handlePointerEnter(event) {
				if (!this.cursor) return

				this.cursor.style.opacity = '1'
				this._handlePointerMove(event)
			}

			_handlePointerMove(event) {
				if (!this.cursor) return

				if (this._frame) cancelAnimationFrame(this._frame)

				this._frame = requestAnimationFrame(() => {
					const bounds = this.getBoundingClientRect()
					const cursorBounds = this.cursor.getBoundingClientRect()
					const top = event.clientY - bounds.top - cursorBounds.height / 2
					const right = bounds.right - event.clientX - cursorBounds.width / 2

					this.style.setProperty('--l-cursor-top', `${top}px`)
					this.style.setProperty('--l-cursor-right', `${right}px`)
					this._frame = null
				})
			}

			_handlePointerLeave() {
				if (!this.cursor) return

				this.cursor.style.opacity = '0'
			}

			_activateCard(activeCardId) {
				this.cards.forEach((card) => {
					card.classList.toggle('is-active', Boolean(activeCardId) && card.dataset.card === activeCardId)
				})

				this.backgrounds.forEach((background) => {
					const cardId = background.dataset.card

					if (cardId) {
						background.classList.toggle('is-active', Boolean(activeCardId) && cardId === activeCardId)
					} else {
						background.classList.toggle('is-active', !activeCardId)
					}
				})
			}

			_handleCardClick(event) {
				const cardId = event.currentTarget.dataset.card
				const isActive = event.currentTarget.classList.contains('is-active')

				this._activateCard(isActive ? null : cardId)
			}

			_handleCardPointerEnter(event) {
				this._activateCard(event.currentTarget.dataset.card)
			}

			_handleCardPointerLeave(event) {
				const related = event.relatedTarget

				if (related?.closest?.('.l-sWHUsV2__card[data-card]')) return

				this._activateCard(null)
			}
		}

		customElements.define('l-section-why-us', LTASectionWhyUs)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-seramar-routine"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-seramar-routine')) {
		class LTASeramarRoutine extends HTMLElement {
			constructor() {
				super()

				this._onTriggerClick = this._onTriggerClick.bind(this)
				this._onBlockSelect = this._onBlockSelect.bind(this)
			}

			connectedCallback() {
				this.triggerEls = [...this.querySelectorAll('[data-trigger]')]
				this.cardEls = [...this.querySelectorAll('[data-card]')]

				if (!this.triggerEls.length || !this.cardEls.length) return

				this.triggerEls.forEach((triggerEl) => {
					triggerEl.addEventListener('click', this._onTriggerClick)
				})

				const activeTrigger =
					this.triggerEls.find((triggerEl) => triggerEl.classList.contains('is-active')) || this.triggerEls[0]

				this.activate(activeTrigger.dataset.trigger)

				if (window.Shopify?.designMode) {
					document.addEventListener('shopify:block:select', this._onBlockSelect)
				}
			}

			disconnectedCallback() {
				this.triggerEls?.forEach((triggerEl) => {
					triggerEl.removeEventListener('click', this._onTriggerClick)
				})

				document.removeEventListener('shopify:block:select', this._onBlockSelect)
			}

			_onTriggerClick(event) {
				this.activate(event.currentTarget.dataset.trigger)
			}

			activate(id) {
				if (!id) return

				this.triggerEls.forEach((triggerEl) => {
					const isActive = triggerEl.dataset.trigger === id

					triggerEl.classList.toggle('is-active', isActive)
					triggerEl.setAttribute('aria-selected', isActive ? 'true' : 'false')
				})

				this.cardEls.forEach((cardEl) => {
					cardEl.classList.toggle('l-hidden', cardEl.dataset.card !== id)
				})
			}

			_onBlockSelect(event) {
				if (!this.contains(event.target)) return

				const triggerEl = event.target.closest('[data-trigger]')
				const cardEl = event.target.closest('[data-card]')

				if (triggerEl) {
					this.activate(triggerEl.dataset.trigger)
					return
				}

				if (cardEl) {
					this.activate(cardEl.dataset.card)
				}
			}
		}

		customElements.define('l-seramar-routine', LTASeramarRoutine)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-three-brands"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-three-brands-card')) {
		class LTAThreeBrandsCard extends HTMLElement {
			connectedCallback() {
				this.links = [...this.querySelectorAll('[data-link]')]

				if (!this.links.length) return

				this._canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches
				this._onLinkEnter = this._onLinkEnter.bind(this)
				this._onLinkLeave = this._onLinkLeave.bind(this)

				if (this._canHover) {
					this.links.forEach((link) => {
						link.addEventListener('pointerenter', this._onLinkEnter)
						link.addEventListener('pointerleave', this._onLinkLeave)
					})
				}

				this._resetPictures()
			}

			disconnectedCallback() {
				this.links?.forEach((link) => {
					link.removeEventListener('pointerenter', this._onLinkEnter)
					link.removeEventListener('pointerleave', this._onLinkLeave)
				})
			}

			_defaultPicture() {
				return this.querySelector('[data-card-picture="default"]')
			}

			_productPictures() {
				return [...this.querySelectorAll('[data-card-picture]:not([data-card-picture="default"])')]
			}

			_resetPictures() {
				this._productPictures().forEach((picture) => picture.classList.remove('is-active'))
				this._defaultPicture()?.classList.add('is-active')
			}

			_onLinkEnter(event) {
				const linkId = event.currentTarget.dataset.link
				const target = this.querySelector(`[data-card-picture="${linkId}"]`)

				if (!target) return

				this._productPictures().forEach((picture) => picture.classList.remove('is-active'))
				this._defaultPicture()?.classList.remove('is-active')
				target.classList.add('is-active')
			}

			_onLinkLeave(event) {
				const related = event.relatedTarget

				if (related?.closest?.('[data-link]')) return

				this._resetPictures()
			}
		}

		customElements.define('l-three-brands-card', LTAThreeBrandsCard)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-tidal-compare-table"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-tidal-compare-table-mobile')) {
		class LTATidalCompareTableMobile extends HTMLElement {
			constructor() {
				super()

				this._onTriggerClick = this._onTriggerClick.bind(this)
			}

			connectedCallback() {
				this.triggerEls = [...this.querySelectorAll('[data-trigger]')]
				this.contentEls = [...this.querySelectorAll('[data-content]')]
				this.swiperCarouselEl = this.querySelector('l-swiper-carousel')

				if (!this.triggerEls.length || !this.contentEls.length) return

				this.triggerEls.forEach((triggerEl) => {
					triggerEl.addEventListener('click', this._onTriggerClick)
				})

				const activeTrigger =
					this.triggerEls.find((triggerEl) => triggerEl.classList.contains('is-active')) || this.triggerEls[0]

				this.activate(activeTrigger.dataset.trigger, { scroll: false })
			}

			disconnectedCallback() {
				this.triggerEls?.forEach((triggerEl) => {
					triggerEl.removeEventListener('click', this._onTriggerClick)
				})
			}

			_onTriggerClick(event) {
				this.activate(event.currentTarget.dataset.trigger)
			}

			activate(id, { scroll = true } = {}) {
				if (!id) return

				this.triggerEls.forEach((triggerEl) => {
					const isActive = triggerEl.dataset.trigger === id

					triggerEl.classList.toggle('is-active', isActive)
					triggerEl.setAttribute('aria-selected', isActive ? 'true' : 'false')
				})

				this.contentEls.forEach((contentEl) => {
					contentEl.classList.toggle('l-hidden', contentEl.dataset.content !== id)
				})

				if (scroll && this.swiperCarouselEl?.slideTo) {
					const index = this.triggerEls.findIndex((triggerEl) => triggerEl.dataset.trigger === id)

					if (index >= 0) this.swiperCarouselEl.slideTo(index)
				}
			}
		}

		customElements.define('l-tidal-compare-table-mobile', LTATidalCompareTableMobile)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-why-us"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-section-why-us')) {
		class LTASectionWhyUs extends HTMLElement {
			connectedCallback() {
				this.cursor = this.querySelector('[data-cursor]')
				this.cards = [...this.querySelectorAll('.l-sWHUs__card[data-card]')]
				this.backgrounds = [...this.querySelectorAll('.l-sWHUs__background[data-card]')]

				if (this.cursor) {
					this.cursor.style.opacity = '0'
					this.cursor.style.pointerEvents = 'none'
				}

				this._canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches

				this._handlePointerEnter = this._handlePointerEnter.bind(this)
				this._handlePointerMove = this._handlePointerMove.bind(this)
				this._handlePointerLeave = this._handlePointerLeave.bind(this)
				this._handleCardClick = this._handleCardClick.bind(this)
				this._handleCardPointerEnter = this._handleCardPointerEnter.bind(this)
				this._handleCardPointerLeave = this._handleCardPointerLeave.bind(this)

				this.addEventListener('pointerenter', this._handlePointerEnter)
				this.addEventListener('pointermove', this._handlePointerMove)
				this.addEventListener('pointerleave', this._handlePointerLeave)

				this.cards.forEach((card) => {
					card.addEventListener('click', this._handleCardClick)

					if (this._canHover) {
						card.addEventListener('pointerenter', this._handleCardPointerEnter)
						card.addEventListener('pointerleave', this._handleCardPointerLeave)
					}
				})
			}

			disconnectedCallback() {
				this.removeEventListener('pointerenter', this._handlePointerEnter)
				this.removeEventListener('pointermove', this._handlePointerMove)
				this.removeEventListener('pointerleave', this._handlePointerLeave)
				this.cards?.forEach((card) => {
					card.removeEventListener('click', this._handleCardClick)
					card.removeEventListener('pointerenter', this._handleCardPointerEnter)
					card.removeEventListener('pointerleave', this._handleCardPointerLeave)
				})

				if (this._frame) cancelAnimationFrame(this._frame)
			}

			_handlePointerEnter(event) {
				if (!this.cursor) return

				this.cursor.style.opacity = '1'
				this._handlePointerMove(event)
			}

			_handlePointerMove(event) {
				if (!this.cursor) return

				if (this._frame) cancelAnimationFrame(this._frame)

				this._frame = requestAnimationFrame(() => {
					const bounds = this.getBoundingClientRect()
					const cursorBounds = this.cursor.getBoundingClientRect()
					const top = event.clientY - bounds.top - cursorBounds.height / 2
					const right = bounds.right - event.clientX - cursorBounds.width / 2

					this.style.setProperty('--l-cursor-top', `${top}px`)
					this.style.setProperty('--l-cursor-right', `${right}px`)
					this._frame = null
				})
			}

			_handlePointerLeave() {
				if (!this.cursor) return

				this.cursor.style.opacity = '0'
			}

			_activateCard(activeCardId) {
				this.cards.forEach((card) => {
					card.classList.toggle('is-active', Boolean(activeCardId) && card.dataset.card === activeCardId)
				})

				this.backgrounds.forEach((background) => {
					const cardId = background.dataset.card

					if (cardId) {
						background.classList.toggle('is-active', Boolean(activeCardId) && cardId === activeCardId)
					} else {
						background.classList.toggle('is-active', !activeCardId)
					}
				})
			}

			_handleCardClick(event) {
				const cardId = event.currentTarget.dataset.card
				const isActive = event.currentTarget.classList.contains('is-active')

				this._activateCard(isActive ? null : cardId)
			}

			_handleCardPointerEnter(event) {
				this._activateCard(event.currentTarget.dataset.card)
			}

			_handleCardPointerLeave(event) {
				const related = event.relatedTarget

				if (related?.closest?.('.l-sWHUs__card[data-card]')) return

				this._activateCard(null)
			}
		}

		customElements.define('l-section-why-us', LTASectionWhyUs)
	}

  } catch(e) { console.error(e); }
})();
})();
